
import { defineComponent, ref, reactive } from 'vue';
import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import PlanoContaModal from './PlanoContaModal.vue';
import ServicoPlanoContas from '@/servicos/Cadastros/PlanosContas/ServicoPlanoContas';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import Icone from '@/core/components/Icone.vue';
import VinculacaoContaContabilReferenciadaModal from './VinculacaoContaContabilReferenciadaModal.vue';

export default defineComponent({
  name: 'PlanoConta',
  components: {
    TelaPadraoCrud,
    PlanoContaModal,
    Icone,
    VinculacaoContaContabilReferenciadaModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud,
    } = useCrudBase();
    const servicoPlanoContas = new ServicoPlanoContas();
    const refCrud = ref<InstanceType<typeof TelaPadraoCrud>>();

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = true;
    crudBase.estrutura.verificarCadastroCompartilhado = true;
    crudBase.estrutura.botaoPrincipalAcao = 'Novo';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão do plano de contas';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Código', dataIndex: 'codigo', key: 'CodigoPlanoConta', identificadorConsulta: 'CodigoPlanoConta', position: 1, visible: false, ordering: true,
      },
      {
        title: 'Descrição', dataIndex: 'descricao', key: 'DescricaoPlanoConta', identificadorConsulta: 'DescricaoPlanoConta', position: 2, visible: true, ordering: true, customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Tipo', dataIndex: 'tipoDescricao', key: 'TipoPlanoConta', position: 3, visible: true, width: 120,
      },
      {
        title: 'Máscara', dataIndex: 'mascara', key: 'MascaraPlanoConta', position: 4, visible: true, width: 120,
      },
      {
        title: 'Status', dataIndex: 'ativo', key: 'AtivoPlanoConta', position: 5, visible: true, align: 'left', customRenderRow: ECustomRenderRow.TagAtivo, width: 100,
      },
      {
        title: 'Ações', key: 'acoes', position: 5, visible: true, fixed: 'right', width: 100, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade.push({ identificador: 'CodigoPlanoConta', ordem: 'DESC' } as IOrdenacao);

    const state = reactive({
      apresentarModalVinculoCategoriaContaReferenciada: false,
    });
    async function sincronizarRegistro(acao: EPermissaoDados, codigoRegistro: number) {
      if (refCrud.value !== undefined) {
        await refCrud.value.sincronizarRegistro(acao, codigoRegistro);
      }
    }

    function abrirVinculoCategoriaContaReferenciada() {
      state.apresentarModalVinculoCategoriaContaReferenciada = true;
    }
    return {
      crudBase,
      servicoPlanoContas,
      state,
      exibirModal,
      sincronizaTelaCrud,
      sincronizarRegistro,
      refCrud,
      abrirVinculoCategoriaContaReferenciada,
    };
  },
});
